export default __webpack_public_path__ + "static/media/BRASÃO SSPDS NOVO.4f85d33f.svg";